
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-cases",
      function () {
        return require("private-next-pages/success-cases.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-cases"])
      });
    }
  